/**
 * Kit collections reducer
 */

import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const kitCollectionsReducer = (state = {}, action) => {
  let kitCollections;
  try {
    kitCollections = action.response.entities.kitCollections;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.REMOVE_KIT_FROM_COLLECTION_SUCCESS: {
      const {
        response: { result },
      } = action;
      return { ...state, [result]: { ...state[result], ...kitCollections[result] } };
    }

    default: {
      if (kitCollections) {
        return _merge({}, state, kitCollections);
      }
      return state;
    }
  }
};

export default kitCollectionsReducer;
